import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { RadioButton, RadioGroupOptions } from '@usitsdasdesign/dds-ng/radio';
import {
  ButtonKind,
  Column,
  ErrorState,
  LabelPosition,
  Size,
  SpinnerThemes,
  WidthState,
} from '@usitsdasdesign/dds-ng/shared';
import { GlobalEngagementsConstant } from './constants/global-engagements.constants';
import { IntakeConstant } from '../intake/constants/intake.constant';
import { TextareaOptions } from '@usitsdasdesign/dds-ng/textarea';
import { SelectOptions } from '@usitsdasdesign/dds-ng/select';
import { ProgressOptions } from '@usitsdasdesign/dds-ng/progress';

export const secondaryButton = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.primary,
  width: WidthState.fixed,
  isLoading: false,
  icon: 'dds-icon_close',
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Cancel',
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const SecondaryLoudButtonOptions: ButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.secondaryLoud,
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: undefined,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: undefined,
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const primaryButton = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.primaryLoud,
  width: WidthState.fixed,
  isLoading: false,
  icon: GlobalEngagementsConstant.EMPTY_STRING,
  arialLabel: 'Confirm',
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: true,
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const closeBtnOptions: ButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.secondary,
  size: Size.md,
  width: WidthState.fixed,
  isLoading: false,
  icon: 'dds-icon_close',
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: GlobalEngagementsConstant.EMPTY_STRING,
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const radioBtns: RadioButton[] = [
  {
    options: {
      label: IntakeConstant.YES,
      theme: GlobalEngagementsConstant.THEME_GREEN,
    },
    value: IntakeConstant.YES,
  },
  {
    options: {
      label: IntakeConstant.NO,
      theme: GlobalEngagementsConstant.THEME_GREEN,
    },
    value: IntakeConstant.NO,
  },
];

export const radioGroupOptions: RadioGroupOptions = {
  name: 'group1',
  disabled: false,
  isError: false,
  errorState: ErrorState.default,
  isUncheckable: false,
  isRequired: false,
  isInverse: false,
};

export const PrimaryButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.primary,
  size: Size.lg,
  width: WidthState.fixed,
};

export const SHOW_MORE_BTN_OPTIONS: ButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.silent,
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: GlobalEngagementsConstant.DDS_ICON_ARROW_UP,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Show Less',
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const ModalCloseButtonOptions: ButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_DARK,
  kind: ButtonKind.silent,
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: GlobalEngagementsConstant.DDS_ICON_CLOSE,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Close modal',
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  role: 'button',
};

export const ToggleGroupOptions = {
  title: GlobalEngagementsConstant.EMPTY_STRING,
  isInverse: false,
  isRequired: false,
};

export const documentTitleTooltipOptions = {
  tooltipInvokeType: 'hover',
  tooltipPosition: 'top',
  tooltipIndent: 15,
  tooltipIsOutsideClick: false,
  tooltipHasBeak: true,
  tooltipIsDisabled: false,
  tooltipIsInverse: false,
  tooltipIsDynamic: false,
  tooltipCustomClass: GlobalEngagementsConstant.EMPTY_STRING,
  tooltipType: 'regular',
  tooltipSize: 'md',
  tooltipShowDelay: 0,
  tooltipHideDelay: 0,
  tooltipTheme: GlobalEngagementsConstant.THEME_DARK,
  tooltipMaxWidth: 300,
};

export const spinnerOptions = {
  theme: SpinnerThemes.gray,
  thickness: '0.188rem',
  size: '1.875rem',
  customClass: GlobalEngagementsConstant.EMPTY_STRING,
  isInverse: false,
};

export const UploaderAreaOptions = {
  heading: '',
  dragAndDropText: 'Drag and drop file(s)',
  description:
    'All common file types are supported, including: docx, pptx, pdf, .zip, etc. Max size of 100MB per file',
  isDragAndDrop: true,
  isMultiple: true,
  acceptFormats: '',
  acceptExtensions: '',
  restrictedFormats: '',
  restrictedExtensions: '',
  exceptSymbols: '',
  btnLabel: 'Select file(s)',
  chooseFileBtnKind: 'primary',
  isDownloadable: false,
  allowFilesWithoutType: false,
  disabled: false,
  isInverse: false,
};

export const textFileOptions: TextareaOptions = {
  placeholder: '',
  minHeight: 100,
  maxLength: 400,
  maxLengthPosition: 'bottom-right',
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
};

export const selectDocumentTypeOptions: SelectOptions = {
  label: '',
  labelPosition: LabelPosition.external,
  description: '',
  placeholder: 'Select type',
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  disabled: false,
  isResponsive: true,
  isRequired: true,
  isInverse: false,
  customClass: '',
  stickerWidth: 0,
  stickerShift: 0,
  stickerMaxHeight: '',
  stickerIsDisabled: false,
  stickerPosition: 'bottom-left',
  stickerIndent: 0,
  stickerCustomClass: '',
  stickerIsDynamic: true,
};

export const selectOptionsStatus: SelectOptions = {
  label: '',
  labelPosition: LabelPosition.external,
  description: '',
  placeholder: 'Select status',
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  disabled: false,
  isResponsive: true,
  isRequired: true,
  isInverse: false,
  customClass: '',
  stickerWidth: 0,
  stickerShift: 0,
  stickerMaxHeight: '',
  stickerIsDisabled: false,
  stickerPosition: 'bottom-left',
  stickerIndent: 0,
  stickerCustomClass: '',
  stickerIsDynamic: true,
};

export const options: ProgressOptions = {
  size: GlobalEngagementsConstant.UI_ELEMENT_SIZE,
  theme: 'green',
  isInverse: false,
  label: '',
  description: '',
  isVertical: false,
};

export const DocumentColumns: Column[] = [
  { name: 'Title', header: 'Title', dataType: 'string' },
  { name: 'Document type', header: 'Document type', dataType: 'string' },
  { name: 'Status', header: 'Status', dataType: 'string' },
  {
    name: 'Comment(optional)',
    header: 'Comment (optional)',
    dataType: 'string',
  },
];

export const linkButton: ButtonOptions = {
  theme: GlobalEngagementsConstant.EXT_THEME_GREEN,
  kind: ButtonKind.primary,
  size: Size.md,
  width: WidthState.fixed,
};
